import React from 'react';
import { Instagram, Phone } from 'lucide-react';
import { Watermark } from './Watermark';
export function Footer() {
  return <footer className="relative overflow-hidden bg-luxury-black text-white py-12 sm:py-16 px-5 sm:px-6 border-t border-gray-800" data-id="element-140" data-mp="3gg0zo4mhnzy6">
      <Watermark position="center" align="top" size={780} opacity={0.07} dark data-id="element-141" data-mp="32lrn9grlb3lk" />
      <div className="relative z-10 max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-142" data-mp="36pzebklisvmy">
        <h2 className="text-2xl font-serif mb-2 tracking-wider" data-id="element-143" data-mp="3ufjuxwu7bgt2">
          ALEXA BEAUTY
        </h2>
        <p className="text-gold text-sm tracking-[0.2em] uppercase mb-8" data-id="element-144" data-mp="387g3ogsjfgb">
          Brows And Lashes
        </p>

        <p className="font-serif italic text-gray-400 mb-8 text-lg" data-id="element-145" data-mp="3lggd0w6rt7g5">
          Belleza profesional con estilo.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 items-center justify-center text-sm font-sans text-gray-300" data-id="element-146" data-mp="29z6woiixuvj2">
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-147" data-mp="2eyt9wryrobrv">
            <Instagram className="w-5 h-5" data-id="element-148" data-mp="3labsrz9e6cry" />
            @alexabeauty
          </a>
          <span className="hidden sm:block text-gray-600" data-id="element-149" data-mp="3gbinuv867u3e">|</span>
          <a href="https://wa.me/16159848577?text=Hola%20Karina%20%F0%9F%91%8B%20Vi%20tus%20servicios%20de%20dise%C3%B1o%20de%20cejas%20en%20Alexa%20Beauty%20y%20me%20gustar%C3%ADa%20agendar%20una%20cita.%20%C2%BFQu%C3%A9%20disponibilidad%20tienes%3F" target="_blank" rel="noopener noreferrer" aria-label="Escribir a Karina por WhatsApp al +1 (615) 984-8577" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-150" data-mp="3v7q2lg0t83ba">
            <Phone className="w-5 h-5" data-id="element-151" data-mp="cu0gsq082r41" />
            +1 (615) 984-8577
          </a>
        </div>

        <div className="mt-10 sm:mt-14 pt-8 border-t border-gray-800 w-full text-xs text-gray-500 font-sans" data-id="element-152" data-mp="qt8ipqnrsdbx">
          &copy; {new Date().getFullYear()} Alexa Beauty. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}